import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const AboutComponent = () => {
  return (

    <div className="container-lg">
      <br></br>
      <div className="row">
        <div className="col">
          <div className="section shadow">
            <br></br>
            <h2>About Us</h2><br></br>
            <p style={{ textAlign: 'left', lineHeight: '250%' }}>
              The Internal Quality Assurance Cell (IQAC) of the institution is committed to
              promoting and sustaining quality in academic and administrative performance.
              Established as a proactive quality enhancement mechanism, the IQAC works
              towards developing a system for conscious, consistent, and catalytic
              improvement in the overall functioning of the college. The cell plays a vital
              role in fostering a learner-centric environment, encouraging innovative
              teaching-learning processes, and ensuring continuous evaluation and
              enhancement of institutional standards in accordance with NAAC guidelines.
            </p><br></br>
            <p>
              <h2>IQAC Function</h2>
              <br></br>
              <ul style={{ textAlign: 'left', lineHeight: '250%' }}>
                <li>Development and application of quality parameters for the various academic and administrative activities of the institution.</li>
                <li>Dissemination of information on the various quality parameters of higher education.</li>
                <li>Organization of workshops, seminars on quality related themes and promotion of quality circles.</li>
                <li>Documentation of the various programmes / activities leading to quality improvement.</li>
                <li>Preparation of the Self Study Report (SSR) Annual Quality Assurance Report (AQAR) to be submitted to NAAC based on the quality parameters.</li>
              </ul>
            </p>
          </div>
        </div>
        {/* <div className="col-md-6">
          <div className="section shadow">
            <h2>IQAC Functions</h2>
            <ul>
              <li>Development and application of quality parameters for the various academic and administrative activities of the institution.</li>
              <li>Dissemination of information on the various quality parameters of higher education.</li>
              <li>Organization of workshops, seminars on quality related themes and promotion of quality circles.</li>
              <li>Documentation of the various programmes / activities leading to quality improvement.</li>
              <li>Preparation of the Self Study Report (SSR) Annual Quality Assurance Report (AQAR) to be submitted to NAAC based on the quality parameters.</li>
            </ul>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AboutComponent;
